export default class ArchiveSort {
    constructor() {
        this.sortTriggers = document.querySelectorAll('.discography__sort__trigger');
        this.sortSelects = document.querySelectorAll('.discography__sort__select');
        this._init();
    }

    _init() {
        this._setupTriggerEvents();
        this._setupDocumentClickEvent();
        this._setupSelectMouseoutEvents();
    }

    _setupTriggerEvents() {
        this.sortTriggers.forEach(trigger => {
            trigger.addEventListener('mouseover', this._handleTriggerMouseover.bind(this, trigger));
            trigger.addEventListener('mouseout', this._handleTriggerMouseout.bind(this, trigger));
            trigger.addEventListener('click', this._handleTriggerClick.bind(this, trigger));
        });
    }

    _handleTriggerMouseover(trigger) {
        if (window.innerWidth > 768) {
            const parent = trigger.closest('.discography__sort__item');
            parent.classList.add('-open');
        }
    }

    _handleTriggerMouseout(trigger, event) {
        if (window.innerWidth > 768) {
            const parent = trigger.closest('.discography__sort__item');
            if (!event.relatedTarget || (event.relatedTarget && !event.relatedTarget.closest('.discography__sort__select'))) {
                parent.classList.remove('-open');
            }
        }
    }

    _handleTriggerClick(trigger) {
        if (window.innerWidth <= 768) {
            const parent = trigger.closest('.discography__sort__item');
            if (parent.classList.contains('-open')) {
                parent.classList.remove('-open');
            } else {
                this.sortSelects.forEach(select => select.closest('.discography__sort__item').classList.remove('-open'));
                parent.classList.add('-open');
            }
        }
    }

    _setupDocumentClickEvent() {
        document.addEventListener('click', this._handleDocumentClick.bind(this));
    }

    _handleDocumentClick(event) {
        if (!event.target.closest('.discography__sort__trigger') && !event.target.closest('.discography__sort__select')) {
            this.sortSelects.forEach(select => select.closest('.discography__sort__item').classList.remove('-open'));
        }
    }

    _setupSelectMouseoutEvents() {
        this.sortSelects.forEach(select => {
            select.addEventListener('mouseout', this._handleSelectMouseout.bind(this, select));
        });
    }

    _handleSelectMouseout(select, event) {
        if (window.innerWidth > 768) {
            if (!event.relatedTarget || (event.relatedTarget && (!event.relatedTarget.closest('.discography__sort__select') && !event.relatedTarget.closest('.discography__sort__trigger')))) {
                select.closest('.discography__sort__item').classList.remove('-open');
            }
        }
    }
}
